import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const BackdropLoader = ({ isLoading }) => {
  return (
    <Backdrop
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        color: "rgb(7, 142, 206)",
      }}
      open={!!isLoading}
    >
      <CircularProgress color="inherit" size={40} thickness={4} />
    </Backdrop>
  );
};

export default BackdropLoader;
